export const PERMS = {
    READ: 'driver_timesheets.read',
    UPDATE: 'driver_timesheets.update',
    DELETE: 'driver_timesheets.delete',
    CREATE: 'driver_timesheets.create',
    EXPORT: 'driver_timesheets.export',
}
